import React from 'react';
import { useSelector } from 'react-redux';
import { dimensionByTypesSelector } from '@store/common/dimensionList/selectors';
import { filterSelector } from '@store/common/selectors';
import { MAPPED_EVENT_DIMENSIONS } from '@utils/dimension/appDimensionHelper';
import {
  findDimensionDetailsInFilter,
  hasMappedEventName,
} from '@src/utils/filter/getDimensionTypesFromFilter';
import StaticTableWidget from '@components/dimension-panel-hz/dimension-table/StaticDimensionTables/StaticTable';

function MappedEventDimensionWidget() {
  const dimensionByTypes = useSelector(dimensionByTypesSelector);
  const filter = useSelector(filterSelector);
  const { dimensionTypes } = findDimensionDetailsInFilter(filter, dimensionByTypes);
  if (!hasMappedEventName(dimensionTypes)) {
    return null;
  }
  return (
    <>
      {MAPPED_EVENT_DIMENSIONS.map((options) => {
        return (
          <StaticTableWidget
            header={options.header}
            dimension={options.dimension}
            key={options.dimension}
          />
        );
      })}
    </>
  );
}

export default MappedEventDimensionWidget;
